/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: DateUtil.ts
 * Created by: ChanYing
 * Create Date: 2022-11-17 15:37
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export class DateUtil {

    private constructor() {
    }

    public static getSystemTimeZoneOffset(): number {
        let nowTime = new Date();
        let offset = nowTime.getTimezoneOffset() / -60;
        return offset;
    }

    public static getCurrentTimestamp(): number {
        return new Date().getTime();
    }

    // Get the current time
    public static getCurrentTime(): string {
        let year = new Date().getFullYear();
        let month = new Date().getMonth() + 1;
        let day = new Date().getDate();
        let m = month.toString().padStart(2, '0');
        let d = day.toString().padStart(2, '0');
        return year + '-' + m + '-' + d;
    }

    // Change the format of the timestamp to yyyy MM dd （millisecond）
    public static convertMillisecondDate(dateTime: string): string {
        let year = new Date(dateTime).getFullYear();
        let month = new Date(dateTime).getMonth() + 1;
        let day = new Date(dateTime).getDate();
        let m = month.toString().padStart(2, '0');
        let d = day.toString().padStart(2, '0');
        return `${year}-${m}-${d}`;
    }

    public static convertDatetime(dateTime: string): string {
        let year = new Date(dateTime).getFullYear();
        let month = new Date(dateTime).getMonth() + 1;
        let day = new Date(dateTime).getDate();
        let m = month.toString().padStart(2, '0');
        let d = day.toString().padStart(2, '0');
        let hours = new Date(dateTime).getHours().toString().padStart(2, '0');
        let minutes = new Date(dateTime).getMinutes().toString().padStart(2, '0');
        let seconds = new Date(dateTime).getSeconds().toString().padStart(2, '0');
        return `${year}-${m}-${d} ${hours}:${minutes}:${seconds}`;
    }

    // Change the format of the timestamp to yyyy MM dd （second）
    public static convertSecondDate(dateTime: string): string {
        const seconds = parseInt(dateTime);
        const date = new Date(seconds * 1000);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const m = month < 10 ? '0' + month : month.toString();
        const d = day < 10 ? '0' + day : day.toString();
        return `${year}-${m}-${d}`;
    }

    public static getConvertDateTime(dateTime: string): string {
        let date = new Date(dateTime);
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');
        let seconds = date.getSeconds().toString().padStart(2, '0');
        // let m = month > 10 ? month : '0' + month;
        // let d = day > 10 ? day : '0' + day;
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    }

    public static getConvertDateTimeToDay(dateTime: string): string {
        let date = new Date(dateTime);
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    /*public static getTimeAgo(timestamp: string | number): string {
        const diff = Date.now() - Number(timestamp);
        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 0) return `${days}day ago`;
        if (hours > 0) return `${hours}hour ago`;
        if (minutes > 0) return `${minutes}min ago`;
        return `moments ago`;
    }*/

    // "2 minutes ago" / "2分钟前", in the console's language. Intl does the wording, so there is no
    // per-unit string to translate. Answers "" for a missing or unreadable time.
    public static relativeTime(dateTime: string | null | undefined, locale: string): string {
        if (!dateTime) {
            return "";
        }
        const then = new Date(dateTime).getTime();
        if (isNaN(then)) {
            return "";
        }
        const seconds = Math.round((then - Date.now()) / 1000);
        const rtf = new Intl.RelativeTimeFormat(locale, {numeric: "auto"});
        const abs = Math.abs(seconds);
        if (abs < 60) return rtf.format(seconds, "second");
        if (abs < 3600) return rtf.format(Math.round(seconds / 60), "minute");
        if (abs < 86400) return rtf.format(Math.round(seconds / 3600), "hour");
        return rtf.format(Math.round(seconds / 86400), "day");
    }
}